(function (ng, app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.Settings.FileManager",
                    {
                        url: "/Files",
                        component: "fileManager",
                        PageTitle: "File Manager | Marketing Tracker"
                    });
        }
    ]);

    app
        .component("fileManager",
            {
                templateUrl: "App/Tools/MarketingTrackerNew/Settings/FileManager/file-manager-template.html",
                controller: filesManagerController,
                bindings: {
                    user: "<"
                }
            });

    filesManagerController.$inject = ['featureToggleService', 'figToaster', '$mdDialog', 'marketingTrackerUserFileApi', 'amplitudeService', '$q', 'fileSizeFilter', '_'];
    function filesManagerController(featureToggleService, figToaster, $mdDialog, marketingTrackerUserFileApi, amplitudeService, $q, fileSizeFilter, _) {
        const $ctrl = this;
        $ctrl.pageSizes = [25, 50, 100];

        function _resetFilters(propertyName, pageSize, reverseOrder, currentPage, fileSearch) {
            $ctrl.propertyName = propertyName || 'ModifiedOn';
            $ctrl.pageSize = pageSize || $ctrl.pageSizes[0];
            $ctrl.reverseOrder = reverseOrder || false;
            $ctrl.currentPage = currentPage || 1;
            $ctrl.fileSearch = fileSearch || '';
        }

        $ctrl.toggleSort = function (propertyName) {
            $ctrl.reverseOrder = $ctrl.propertyName === propertyName ? !$ctrl.reverseOrder : false;
            $ctrl.propertyName = propertyName;
        };

        $ctrl.showDetails = function ($event, file) {
            return $mdDialog.show({
                templateUrl: "App/Tools/MarketingTrackerNew/Components/FileDetails/file-details.component.html",
                controller: "fileDetailsController",
                controllerAs: "$ctrl",
                targetEvent: $event,
                locals: {
                    file: file,
                    user: $ctrl.user
                },
                onComplete: console.log('On Complete'),
                bindToController: true
            });
        };

        $ctrl.uploadFiles = function (files, invalidFiles) {
            var promises = [];
            if ($ctrl.uploadForm.$invalid) {
                var invalidFileNames = _.map(invalidFiles,
                    function (file) {
                        return file.name;
                    }).join(", ");
                var toastClass = 'is-error';
                var toastMessage;
                //Added custom system feedback based on form validation
                if ($ctrl.uploadForm.$error.maxSize) {
                    toastMessage = 'File size cannot exceed 30MB per file. Please upload a different file.';
                }
                if ($ctrl.uploadForm.$error.pattern) {
                    toastMessage = 'File type is not supported. Please upload a different file.';
                }
                figToaster.showSimple(invalidFileNames + ' not uploaded. ' + toastMessage, "top", toastClass);
            }

            if (files.length > 0 && $ctrl.uploadForm.$valid) {
                $ctrl.uploadingFiles = true;
                files.successCount = 0;

                ng.forEach(files, function (file) {
                    file.upload = {
                        progress: 0,
                        status: {
                            inProgress: false,
                            success: false,
                            error: false
                        }
                    };

                    var payload = new FormData();

                    var config = {
                        uploadEventHandlers: {
                            progress: function (event) {
                                //Set at 95% since post-upload processing still takes a considerable amount of time
                                file.upload.progress = Math.round((event.loaded * 95) / event.total);
                                file.upload.status.inProgress = file.upload.progress > 0 ? true : false;
                            }
                        }
                    };
                    //We set the payload once per file upload since the backend only streams one file at a time
                    payload.set('userFile', file, file.name);

                    //Return a promise and give system feedback for each upload
                    promises.push(marketingTrackerUserFileApi.uploadUserFile(payload, config)
                        .then(function () {
                            files.successCount += 1;
                            file.upload.status.success = true;
                            file.upload.progress = 100;
                            amplitudeService.logCustomEvent('File Manager Upload', file.name, {
                                file_name: file.name,
                                file_type: file.type,
                                file_size: file.size
                            });
                        })
                        .catch(function () {
                            file.upload.status.error = true;
                        })
                        .finally(function () {
                            file.upload.status.inProgress = false;
                        }));
                });
                //Retrieve file list when at least one file succeeded
                $q.all(promises).finally(function () {
                    if (files.successCount > 0 || files.successCount === files.length) {
                        if (files.successCount === files.length) {
                            toastMessage = 'Files are done uploading.';
                            toastClass = "is-success";
                        } else {
                            toastMessage = 'Some files did not upload. Please try again.';
                            toastClass = "is-alert";
                        }
                        marketingTrackerUserFileApi.getFiles()
                            .then(function (response) {
                                $ctrl.fileList = response;
                            });
                    } else {
                        toastMessage = 'There was a problem adding your files. Please try again shortly.';
                        toastClass = "is-error";
                    }

                    return figToaster.showSimple(toastMessage, "top", toastClass);
                });
            }
        };

        $ctrl.downloadFile = function (file) {
            marketingTrackerUserFileApi.downloadFile(file.Id)
                .then(function (response) {
                    var f = document.createElement("a");
                    document.body.appendChild(f);
                    f.style = "display: none";

                    var fUrl = window.URL.createObjectURL(response);
                    f.href = fUrl;
                    f.download = file.FileName + file.FileExtension;
                    f.click();

                    setTimeout(function () {
                        document.body.removeChild(file);
                        window.URL.revokeObjectURL(fUrl);
                    }, 100);
                })
                .then(function () {
                    amplitudeService.logCustomEvent('File Manager Download', file.FileName, {
                        file_name: file.FileName + file.FileExtension,
                        file_type: file.ContentType,
                        file_size: file.Size
                    });
                });
        };

        $ctrl.deleteFile = function ($event, file) {
            var confirm = $mdDialog.confirm({
                title: "Are you sure you want to delete this file? This action is permanent.",
                targetEvent: $event,
                ariaLabel: "Confirm list removal",
                ok: "Delete File",
                cancel: "Cancel",
                multiple: true,
                clickOutsideToClose: false
            });
            $mdDialog.show(confirm)
                .then(function () {
                    file.delete = {
                        status: {
                            inProgress: true
                        }
                    };
                    marketingTrackerUserFileApi.deleteFile(file.Id)
                        .then(function () {
                            $ctrl.fileList = _.without($ctrl.fileList, file);
                            toastMessage = "File deleted.";
                            toastClass = "is-success";
                        })
                        .catch(function () {
                            toastMessage = "There was a problem deleting your file. Please try again shortly.";
                            toastClass = "is-error";
                        })
                        .finally(function () {
                            file.delete.status.inProgress = false;
                            figToaster.showSimple(toastMessage, "top", toastClass);
                        });
                });
        };

        $ctrl.$onInit = function () {
            $ctrl.env = featureToggleService.checkEnv();
            $ctrl.toggleFeature = featureToggleService.checkEnv();
            $ctrl.pageSize = $ctrl.pageSizes[1];
            $ctrl.propertyName = 'ModifiedOn';
            $ctrl.reverseOrder = true;
            $ctrl.currentPage = 1;
            $ctrl.fileSearch = '';
            $ctrl.loadingData = true;
            marketingTrackerUserFileApi.getFiles()
                .then(function (response) {
                    $ctrl.fileList = response;
                })
                .finally(function () {
                    $ctrl.loadingData = false;
                });
        };
    }

})(window.angular, window.app); //jshint ignore:line